import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { isNotEmpty, parseClasses } from '../../lib/ep.js';
import Autosuggest from 'react-autosuggest';

import FieldLabel from './FieldLabel';
import FieldErrorMessage from './FieldErrorMessage';
import Loader from './Loader';

class Autocomplete extends Component {
	constructor(props,context) {
		super(props, context);
		this.state = {
			value:'',
			suggestions:[],
			is_fetching:false,
		}
	}

	//This will obtain all the values to display.
	fetch(value) {
		if(this.props.fetch) {
			this.setState({ is_fetching:true });
			this.props.fetch(value,this.fetched.bind(this));
		}
		if(this.props.onChange != undefined) this.props.onChange(value.value);
	}

	fetched(suggestions) {
		if(suggestions!=undefined)this.setState({ suggestions });
		this.setState({ is_fetching:false });
	}

	//Action to dispatch when selected
	onSuggestionSelected(e, i) {

		if(this.props.selected) {
			this.props.selected(i);
			if (typeof i.suggestion.value !== 'object')
			this.setState({ value:i.suggestion.value });
		} else {
			this.setState({ value:i.suggestionValue });
		}
		if(this.props.autoclear) {
			this.setState({ value:'' });
		}
	}

	//Clear results
	onSuggestionsClearRequested() {
		this.setState({ suggestions:[] });
	}

	//We assume its the item id what we want
	getSuggestionValue(item) {
		if(this.props.suggestId) {
			return item[this.props.suggestId];
		}
		return item.id;
	}

	//Use a default renderer
	renderSuggestion(suggestion) {
		return (
			<div>{suggestion.value}</div>
		)
	}

	render() {
		const placeholder = (this.props.placeholder != undefined) ? ((this.props.autotranslate_placeholder != undefined && this.props.autotranslate_placeholder) ? this.props.intl.formatMessage({id:this.props.placeholder}) : this.props.placeholder) : '';

		const _styles = (this.props._style != undefined) ? this.props._style : {};
		const _field_styles = (this.props._field_style != undefined) ? this.props._field_style : {};

		const has_error = (this.props.errors && this.props.errors[this.props.name]) ? this.props.errors[this.props.name] : false;

		var classname = (this.props.classname != undefined) ? this.props.classname : 'input text autocomplete';
		classname = parseClasses(classname, this.props._class, 'autocomplete');

		const inputProps = {
			placeholder:placeholder,
			value:this.state.value,
			className:'common_form_item',
			onChange:(e) => { this.setState({ value:e.target.value }) }
		};

		return (
			<div class={'react_field gui_input_with_loader' + ((this.props._field_class != undefined) ? ' ' + this.props._field_class : '')} onMouseEnter={(this.props.onMouseEnter != undefined) ? this.props.onMouseEnter : null} onMouseLeave={(this.props.onMouseLeave != undefined) ? this.props.onMouseLeave : null} onFocus={(this.props.onFocus != undefined) ? this.props.onFocus : null} onBlur={(this.props.onBlur != undefined) ? this.props.onBlur : null} onClick={(this.props.onClick != undefined) ? this.props.onClick : null} style={_field_styles}>
				<div class={classname + ((has_error) ? ' has_error' : '')} style={_styles}>
					{this.props.children && (
						<FieldLabel
							{...this.props.label_props}
							name={this.props.name}
							autotranslate={this.props.autotranslate}
						>{this.props.children}</FieldLabel>
					)}

					<div class="field_container this_input">
						<Autosuggest
							suggestions={this.state.suggestions}
							onSuggestionsFetchRequested={this.fetch.bind(this)}
							onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
							getSuggestionValue={this.getSuggestionValue.bind(this)}
							renderSuggestion={this.renderSuggestion}
							onSuggestionSelected={this.onSuggestionSelected.bind(this)}
							inputProps={inputProps}
						/>

						{(has_error) && (
							<FieldErrorMessage error_msg_position_class={this.props.error_msg_position_class}>{has_error}</FieldErrorMessage>
						)}

						{(isNotEmpty(this.props,'after_message')) && (
							<div class="gui_after_message">{this.props.intl.formatMessage({id:this.props.after_message})}</div>
						)}


						{(this.props.after_component != undefined) && (
							<span class="label_additional_msg gui_after_message whole_contents">{this.props.after_component}</span>
						)}

						{(this.state.is_fetching) && (
							<Loader color="#000000" />
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default injectIntl(Autocomplete);